import { styled } from "styled-components";
import { ErrorOutlined } from "@gds-react/icons";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  padding: ${({ theme }) => theme.spacing[5]};
`;

export const SmallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing[2]};
`;

export const SmallIcon = styled(ErrorOutlined)`
  color: ${({ theme }) => theme.colors.text.secondary.color};
  width: 20px;
  height: 20px;
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.fonts.medium.fontSize};
  color: ${({ theme }) => theme.colors.text.primary.color};
  margin-bottom: ${({ theme }) => theme.spacing[5]};
  text-align: center;
  font-weight: 700;
  max-width: 80%;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fonts.medium.fontSize};
    max-width: 100%;
  }
`;

export const Description = styled.div`
  font-size: ${({ theme }) => theme.fonts.base.fontSize};
  color: ${({ theme }) => theme.colors.text.secondary.color};
  margin-bottom: ${({ theme }) => theme.spacing[5]};
  text-align: center;
  max-width: 80%;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fonts.base.fontSize};
    max-width: 100%;
  }
`;

export const TraceIdBadge = styled.div`
  font-size: ${({ theme }) => theme.fonts.sm.fontSize};
  color: ${({ theme }) => theme.colors.text.primary.color};
  background-color: ${({ theme }) => theme.colors.background.layers[500]};
  padding: ${({ theme }) => theme.spacing[2]}
    ${({ theme }) => theme.spacing[3]};
  border-radius: ${({ theme }) => theme.spacing[1]};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
  text-align: center;
`;

export const TraceIdBadgeLink = styled.a`
  font-size: ${({ theme }) => theme.fonts.sm.fontSize};
  color: ${({ theme }) => theme.colors.text.primary.color};
  background-color: ${({ theme }) => theme.colors.background.layers[500]};
  padding: ${({ theme }) => theme.spacing[2]}
    ${({ theme }) => theme.spacing[3]};
  border-radius: ${({ theme }) => theme.spacing[5]};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
  text-align: center;
`;

export const ButtonWrapper = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.spacing[4]};
  right: ${({ theme }) => theme.spacing[4]};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  min-width: 30px;
  height: 30px;
  transition: background-color 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.colors.background.layers[500]};
  border: none;
  border-radius: 50%;
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.colors.text.primary.color};
  }

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.background.layers["400"]};
  }
`;
